import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error - this is a known benign browser issue
// that occurs with responsive charts and doesn't affect functionality
// See: https://github.com/recharts/recharts/issues/2283
const resizeObserverErr = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErrOverlay = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErrDiv) resizeObserverErrDiv.style.display = 'none';
    if (resizeObserverErrOverlay) resizeObserverErrOverlay.style.display = 'none';
    e.stopImmediatePropagation();
    return;
  }
};
window.addEventListener('error', resizeObserverErr);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ── PWA service worker registration ────────────────────────────────
// The worker at /service-worker.js is a pure pass-through (no caching,
// no offline fallback) — its only purpose is to make Chrome / Edge
// desktop offer "Install Precision Fish Detection". Skips registration
// in unsupported browsers and during CRA jest tests.
if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'test') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        // Non-fatal — the site keeps working, only PWA install is lost.
        // eslint-disable-next-line no-console
        console.warn('PFD service worker registration failed:', err);
      });
  });
}
